import { Form, Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal, UpsertSiteFormBody } from "src/app/components";
import Pacman from "src/app/components/layout/Pacman";
import {
    useGetSiteById,
    usePBNOptions,
    useRegistrarAccountOptions,
    useThematicsOptions,
    useUserByRoleOptions,
} from "src/app/hooks";
import { SiteTransport } from "src/app/transports/site";
import { IUpsertModal } from "src/app/types/actionsModal";
import { UpsertSiteDTOSchema } from "src/app/types/Site";
import { apiToFormikErrors } from "src/app/utils/formHelpers";

const UpsertSiteFormBodyModalContainer = (props: IUpsertModal<{ id: number }>) => {
    const { handleClose = () => {}, entity, showModal, updateGridOnSave } = props;

    const [loading, setLoading] = useState(false);

    const { formatMessage } = useIntl();
    const { thematicsOptions, loading: thematicLoading } = useThematicsOptions();
    const { PBNOptions, loading: PBNLoading } = usePBNOptions();
    const { registrarAccountOptions, loading: registrarLoading } = useRegistrarAccountOptions();
    const { adminsOptions, linkersOptions, managersOptions } = useUserByRoleOptions();
    const { site, loading: siteLoading, refresh } = useGetSiteById(entity?.id);

    useEffect(() => {
        if (showModal && entity?.id && !siteLoading) {
            refresh(entity?.id);
        }
    }, [showModal, entity?.id]);

    const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
        if (!values) return;
        setLoading(true);
        try {
            setLoading(true);
            await SiteTransport.save(values, entity?.id);
            toast.success(formatMessage({ id: "common.notification.success" }));
            updateGridOnSave && updateGridOnSave({}, true);
            handleClose();
        } catch (err: any) {
            toast.error(formatMessage({ id: "common.notification.error" }));
            apiToFormikErrors(err?.response, formikHelpers);
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            entityName={`${formatMessage({ id: "common.entity.site" })}`}
            formId="upsertSite"
            loading={siteLoading || loading}
            handleClose={handleClose}
            showModal={showModal}
            modalProps={{ size: "xl" }}
        >
            {siteLoading ? (
                <Pacman />
            ) : (
                <Formik
                    initialValues={
                        site
                            ? SiteTransport.formTransformer(site)
                            : UpsertSiteDTOSchema.getDefault()
                    }
                    onSubmit={onSubmit}
                    enableReinitialize={true}
                    validationSchema={UpsertSiteDTOSchema}
                >
                    <Form id="upsertSite">
                        <UpsertSiteFormBody
                            thematics={{ options: thematicsOptions, loading: thematicLoading }}
                            pbn={{ options: PBNOptions, loading: PBNLoading }}
                            registrarAccount={{
                                options: registrarAccountOptions,
                                loading: registrarLoading,
                            }}
                            usersList={{
                                admins: adminsOptions,
                                linkers: linkersOptions,
                                managers: managersOptions,
                            }}
                        />
                    </Form>
                </Formik>
            )}
        </SimpleModal>
    );
};

export default UpsertSiteFormBodyModalContainer;
